import { h, Component } from "preact";

const InputWrapper = ({ touched, error }) => {
  return touched && error ? <div style={{ color: "red" }}>{error}</div> : "";
};

export default InputWrapper;
